module.exports = "/images/popover_card_cover.jpg?c489e9a5254223f02351db46e0b64f1c";